import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { FileServerLinkedService } from 'app/model/linkedservice/file-server.linkedservice';
import {
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableSecretBaseToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FileServerLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                host: '*',
                userId: '*',
                password: 'secret',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class FileSystemLinkedServiceAdapter extends LinkedServiceAdapter<FileServerLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => FileServerLinkedService {
        return FileServerLinkedService;
    }

    protected model(): IModel {
        return FileServerLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: FileServerLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.FileServerLinkedService;

        properties.type = Metamodel.modelFor(FileServerLinkedService).name;

        properties.typeProperties = {
            host: this.valueToResource(linkedService, FileServerLinkedService.HOST),
            userId: this.valueToResource(linkedService, FileServerLinkedService.USER_NAME),
            password: parameterizablePasswordOrAKVtoSecretBase(linkedService, FileServerLinkedService.PASSWORD, this.context)
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: FileServerLinkedService): Promise<FileServerLinkedService> {
        const properties = linkedServiceResource.properties as Model.FileServerLinkedService;
        const typeProperties: Model.FileServerLinkedServiceTypeProperties = properties.typeProperties;

        ValueAdapter.toModel(linkedService, FileServerLinkedService.HOST, typeProperties.host);
        ValueAdapter.toModel(linkedService, FileServerLinkedService.USER_NAME, typeProperties.userId);
        parameterizableSecretBaseToModel(linkedService, FileServerLinkedService.PASSWORD, typeProperties.password, this.context);

        return linkedService;
    }
}
